import { CollectionViewer, DataSource, SelectionModel } from '@angular/cdk/collections';
import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';
import { OrderService } from 'src/app/data/order.service';
import { Filter } from 'src/app/models/common/filter';
import { OrderStartRealizationItemsDto } from 'src/app/models/dtos/orders/order-start-realization-items-dto';
import { IPagedResult } from 'src/app/shared/models/PagedResult';

@Injectable()
export class OrdersStartRealizationListDataSource extends DataSource<OrderStartRealizationItemsDto> {
  private orderService = inject(OrderService);

  public orderStartRealizationItemsSubject = new BehaviorSubject<OrderStartRealizationItemsDto[]>([]);
  private countSubject = new BehaviorSubject<number>(0);
  public count$ = this.countSubject.asObservable();
  private loadingSubject = new BehaviorSubject<boolean>(true);
  public loading$ = this.loadingSubject.asObservable();


  constructor() {
    super();
  }

  selection = new SelectionModel<OrderStartRealizationItemsDto>(true, []);

  connect(collectionViewer: CollectionViewer): Observable<OrderStartRealizationItemsDto[]> {
    return this.orderStartRealizationItemsSubject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer): void {
    this.orderStartRealizationItemsSubject.complete();
    this.loadingSubject.complete();
    this.countSubject.complete();
  }

  fetchOrderStartRealizationItems(
    page: number,
    count: number,
    sortingField: string,
    sortingDirection: string,
    filters: Filter[]
  ) {
    this.loadingSubject.next(true);
    const response$ = this.orderService
      .getStartRealizationItems(page, count, sortingField, sortingDirection, filters)
      .pipe(
        catchError(() => of([])),
        finalize(() => this.loadingSubject.next(false))
      )

    const orderStartRealizationItems$ = response$.pipe(map((response: IPagedResult<OrderStartRealizationItemsDto>) => response.Results));
    const count$ = response$.pipe(map((response: IPagedResult<OrderStartRealizationItemsDto>) => response.Count));

    orderStartRealizationItems$.subscribe(result => this.orderStartRealizationItemsSubject.next(result));
    count$.subscribe(count => this.countSubject.next(count));
  }
}